export default __webpack_public_path__ + "static/figure8_anim-fdc9d5d2531abea99dc893865d64bfeb.mp4";